export function formatMsg(msg: string, separator: string, separator2: string): { title: string, errors: string[] } {
    const source = msg.split(separator);
    const title = source.shift() || '';
    const errors = source[0]?.split(separator2).map(item => item.trim()) || [];

    return {title: title, errors: errors};
}